// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"5007f48e","1771":"e307bb9c","2264":"39df8550","5130":"0a56aafb","6533":"7fe95281","8035":"5266e703"}[chunkId] + ".chunk.css";
};